module.exports = __webpack_public_path__ + "static/media/butterfly-eco-ecology-svgrepo-com.4d53a9f5.svg";